
export const starLangCode = [
	'orderReviews_oneStar',
	'orderReviews_twoStar',
	'orderReviews_threeStar',
	'orderReviews_fourStar',
	'orderReviews_fiveStar'
];
export const navBarInfo={
	backFlag: true,
};